"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.getIsDocumentErroredByUrn = exports.getErrorByDocumentVersionId = exports.getDocumentsState = exports.getDocumentsByUrn = exports.getDocumentByDocumentVersionId = exports.fetchIssuesDocumentAssociations = exports.fetchDocumentsSuccess = exports.fetchDocumentsError = exports.fetchDocumentsByUrns = exports.fetchDocumentsByDocumentVersionIds = exports.STATE_KEY = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _DocsApi = require("../../../docs-service/DocsApi");
var _pushpinHelpers = require("../../../utils/data/pushpinHelpers");
const initialState = {
  documentsByUrn: {},
  documentsByVersionId: {},
  documentErrorsByVersionId: {},
  documentFetchAttemptsByUrn: {}
};
const documentsSlice = (0, _toolkit.createSlice)({
  name: "documents",
  initialState,
  reducers: {
    fetchDocumentsSuccess: (state, action) => {
      const documentUrnsAttempted = action.payload.documentUrns || [];
      action.payload.documents.forEach(document => {
        state.documentsByUrn[document.urn] = document;
        state.documentsByVersionId[document.version.id] = document;
      });
      // the SDK doesn't expose errors when we get a batch of docs by URN,
      // but if we keep track of what got attempted and compare it to what we received
      // we can figure out the ones that didn't get fetched
      documentUrnsAttempted.forEach(documentUrn => {
        state.documentFetchAttemptsByUrn[documentUrn] = true;
      });
    },
    fetchDocumentsError: (state, action) => {
      action.payload.errors.forEach(error => {
        state.documentErrorsByVersionId[error.id] = error;
      });
    }
  }
});
const {
  fetchDocumentsSuccess,
  fetchDocumentsError
} = documentsSlice.actions;
exports.fetchDocumentsError = fetchDocumentsError;
exports.fetchDocumentsSuccess = fetchDocumentsSuccess;
const reducer = exports.reducer = documentsSlice.reducer;
const STATE_KEY = exports.STATE_KEY = documentsSlice.name;
const getDocumentsState = state => state[STATE_KEY];
exports.getDocumentsState = getDocumentsState;
const getDocumentsByUrn = state => getDocumentsState(state).documentsByUrn;
exports.getDocumentsByUrn = getDocumentsByUrn;
const getIsDocumentErroredByUrn = state => documentUrn => {
  const documentsState = getDocumentsState(state);
  return documentsState.documentFetchAttemptsByUrn[documentUrn] && !documentsState.documentsByUrn[documentUrn];
};
exports.getIsDocumentErroredByUrn = getIsDocumentErroredByUrn;
const getDocumentByDocumentVersionId = state => documentVersionId => {
  if (!documentVersionId) {
    return undefined;
  }
  const documentsState = getDocumentsState(state);
  return documentsState.documentsByVersionId[documentVersionId];
};
exports.getDocumentByDocumentVersionId = getDocumentByDocumentVersionId;
const getErrorByDocumentVersionId = state => documentVersionId => {
  if (!documentVersionId) {
    return undefined;
  }
  const documentsState = getDocumentsState(state);
  return documentsState.documentErrorsByVersionId[documentVersionId];
};
exports.getErrorByDocumentVersionId = getErrorByDocumentVersionId;
const fetchDocumentsByUrns = _ref => {
  let {
    documentUrns,
    useCache = false
  } = _ref;
  return async (dispatch, getState, _ref2) => {
    let {
      sdk
    } = _ref2;
    let documents;
    const fetchedIssuesDocumentAssociations = getDocumentsState(getState()).documentsByUrn;
    const isAlreadyFetched = documentUrns.every(documentUrn => documentUrn in fetchedIssuesDocumentAssociations);
    if (useCache && isAlreadyFetched || !documentUrns.length) {
      return;
    }
    try {
      documents = await (0, _DocsApi.getDocsApi)().Projects.getDocuments(sdk.projectId, documentUrns);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Documents fetch error:", err);
      return;
    }
    dispatch(fetchDocumentsSuccess({
      documents,
      documentUrns
    }));
  };
};
exports.fetchDocumentsByUrns = fetchDocumentsByUrns;
const fetchIssuesDocumentAssociations = _ref3 => {
  let {
    issues,
    useCache = false
  } = _ref3;
  return async (dispatch, getState, _ref4) => {
    let {
      sdk
    } = _ref4;
    const documentUrns = [...new Set(issues.filter(issue => (0, _pushpinHelpers.hasLinkedDocument)(issue)).map(issue => (0, _pushpinHelpers.getLinkedDocument)(issue).urn))];
    let documents;
    const fetchedIssuesDocumentAssociations = getDocumentsState(getState()).documentsByUrn;
    const isAlreadyFetched = documentUrns.every(documentUrn => documentUrn in fetchedIssuesDocumentAssociations);
    if (useCache && isAlreadyFetched || !issues.length) {
      return;
    }
    try {
      documents = await (0, _DocsApi.getDocsApi)().Projects.getDocuments(sdk.projectId, documentUrns);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Documents fetch error:", err);
      return;
    }
    dispatch(fetchDocumentsSuccess({
      documents,
      documentUrns
    }));
  };
};

/*
 * Makes the request to populate the store with a map of
 * sheet ids to the sheet data
 */
exports.fetchIssuesDocumentAssociations = fetchIssuesDocumentAssociations;
const fetchDocumentsByDocumentVersionIds = _ref5 => {
  let {
    documentVersionIds,
    useCache = false,
    onError
  } = _ref5;
  return async (dispatch, getState, _ref6) => {
    let {
      sdk
    } = _ref6;
    let response;
    const fetchedDocumentsByVersionId = getDocumentsState(getState()).documentsByVersionId;
    const isAlreadyFetched = documentVersionIds.every(id => id in fetchedDocumentsByVersionId);
    if (useCache && isAlreadyFetched || !documentVersionIds.length) {
      return;
    }
    try {
      response = await (0, _DocsApi.getDocsApi)().Projects.getDocumentsByIds(sdk.projectId, {
        ids: [...new Set(documentVersionIds.filter(Boolean))]
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Documents fetch error:", err);
      // currently we don't do anything if this fails.
      // but for disambiguating from a cache hit for testing,
      // and to allow notifications, we call an onError function
      onError && onError(err);
      return;
    }
    if (response.errors.length) {
      dispatch(fetchDocumentsError({
        errors: response.errors
      }));
    }
    if (response.results.length) {
      dispatch(fetchDocumentsSuccess({
        documents: response.results
      }));
    }
  };
};
exports.fetchDocumentsByDocumentVersionIds = fetchDocumentsByDocumentVersionIds;
//# sourceMappingURL=documents.js.map